import React, {useEffect, useState} from 'react'
import Pagination from '@material-ui/lab/Pagination';
import PropTypes from 'prop-types';
import {getPaginationConfig} from "hooks/useSearch";
import GridBlock from "./GridBlock";
import {makeStyles, TextField} from "@material-ui/core";
import Typography from "./Typography";
import IconButton from "./button/IconButton";
import ArrowIcon from '@material-ui/icons/KeyboardArrowRight'
import Tr from 'translations/Translations'

const useStyles = makeStyles(theme => ({
    root: {
        marginTop: theme.spacing()
    },
    pageInputInput: {
        "&>input": {
            textAlign: 'center'
        }
    },
    pageInput: {
        width: theme.components.input.criteria.width,
        marginLeft: theme.spacing()
    },
    emptyWidth: {
        width: 200
    },
    goToPage: {
        userSelect: 'none'
    }
}));

function DottedPagination(
    {
        config = getPaginationConfig(1, 10),
        setConfig = () => {
        },
        totalCount = 0,
        disabled,
        showManualInputField = true
    }) {

    const classes = useStyles();
    const [pageValue, setPageValue] = useState("");
    const handleChangePage = (event, newPage) => {
        setConfig({...config, page: newPage});
    }

    useEffect(() => {
        setPageValue((""))
    }, [config])

    const changePage = (e) => {
        let value = e.target.value;
        if (/^\d+$/.test(value)) {
            const intVal = parseInt(value);
            if (intVal >= 1 && intVal <= totalCount) {
                setPageValue(value);
            }
        } else if (value === "") {
            setPageValue(value);
        }
    }

    const handleKeyUp = (e) => {
        if (e.key === 'Enter') {
            handleConfirmPageValue();
        }
    }

    const handleConfirmPageValue = () => {
        if (pageValue !== "") {
            setConfig({...config, page: parseInt(pageValue)});
        }
    }

    return (
        <GridBlock className={classes.root} justify='space-between'>
            {showManualInputField && <div className={classes.emptyWidth}></div>}
            <Pagination
                count={Math.ceil(totalCount/ config.pageSize)}
                page={config.page}
                onChange={handleChangePage}
                showFirstButton
                showLastButton
                size="large"
                color="primary"
                siblingCount={showManualInputField ? 1 : 2}
                boundaryCount={showManualInputField ? 2 : 3}
                disabled={disabled}
            />
            {showManualInputField && <GridBlock alignItems='center'>
                <Typography className={classes.goToPage}>{Tr('go_to_page')}:</Typography>
                <TextField
                    className={classes.pageInput}
                    id='list-search'
                    onChange={changePage}
                    onKeyUp={handleKeyUp}
                    value={pageValue}
                    disabled={disabled || totalCount <= 1}
                    InputProps={{
                        className: classes.pageInputInput
                    }}
                />
                <IconButton
                    Icon={ArrowIcon}
                    disabled={pageValue === ""}
                    onClick={handleConfirmPageValue}
                />
            </GridBlock>}
        </GridBlock>

    )
}

DottedPagination.propTypes = {
    config: PropTypes.shape({
        page: PropTypes.number,
        pageSize: PropTypes.number
    }),
    setConfig: PropTypes.func,
    totalCount: PropTypes.number,
    disabled: PropTypes.bool,
    showCustomInput: PropTypes.bool
}

export default DottedPagination;